import axiosInstance from '../axiosInterceptor/axiosInstance'

const getPlayerCareerStats = async ({ orgId, playerId }) => {
  const url = `v1/orgs/${orgId}/stats/players/${playerId}/career`
  return axiosInstance.get(url)
}

export default getPlayerCareerStats
